import Popper from "@mui/material/Popper";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";

const StyledPopper = ({
    message,
    anchorEl,
    afterResponse,
    open,
    id,
    sx
}) => {
    return (
        <Popper open={open} anchorEl={anchorEl} id={id} sx={{zIndex: 1000}}>
            <Paper
                sx={{
                    p: 2,
                    minWidth: 200,       // 👈 aggiungi qui
                    minHeight: 80,       // 👈 aggiungi qui
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    alignItems: "center",
                    justifyContent: "center",
                    ...sx
                }}
            >
                <Typography>{message}</Typography>

                <Box display="flex" justifyContent="space-around" width="100%">
                    <Button onClick={(e) => {e.stopPropagation(); afterResponse('YES')}}>YES</Button>
                    <Button onClick={(e) => {e.stopPropagation(); afterResponse('NO')}}>NO</Button>
                </Box>
            </Paper>
        </Popper>
    );
};

export default StyledPopper;